import { createContext, useContext } from 'react';
export const RootDocumentContext = createContext({
    rootDocument: document,
});
export const useRootDocumentContext = () => useContext(RootDocumentContext);
